export enum refundReasonEnum {
  WRONG_ITEM = "wrong_item",
  OTHER = "other",
  DAMAGED_ITEM = "damaged_item",
  NOT_AS_DESCRIBED = "not_as_described",
  ACCIDENTAL_PURCHASE = "Payment Error",
}
